import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";

import NotificationView from "../../components/notificationView/NotificationView";
import { uiStateOperations, uiStateSelectors } from "../../modules/uiState";
import { PropTypeShapes } from "../../types";
import { mergeDispatchToProps } from "../../utils/codeSplit";

class NotificationPanel extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { notification, onActionLinkClick } = this.props;
    return notification ? (
      <NotificationView
        label={notification.label}
        actions={notification.actions}
        onCloseClick={this.props.onCloseClick}
        onActionLinkClick={onActionLinkClick}
      />
    ) : (
      false
    );
  }
}

NotificationPanel.propTypes = {
  notification: PropTypeShapes.uiNotification,
  onCloseClick: PropTypes.func.isRequired,
  onActionLinkClick: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  return {
    notification: uiStateSelectors.getUiStateNotification(state.present)
  };
};

const readonlyActions = {};

const editingActions = {
  onCloseClick: uiStateOperations.removeNotification,
  onActionLinkClick: action => action
};

const mapDispatchToProps = dispatch => mergeDispatchToProps(readonlyActions, editingActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(NotificationPanel);
